import { render, staticRenderFns } from "./CouponChooseWithMerchant.vue?vue&type=template&id=7f12e818&scoped=true"
import script from "./CouponChooseWithMerchant.vue?vue&type=script&lang=js"
export * from "./CouponChooseWithMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f12e818",
  null
  
)

export default component.exports